import { AppDeploymentRef } from "./app-deployment.entity"

export const buildAppChannelId = (ref: AppDeploymentRef) =>
  `${ref.appId}|${ref.channelId}`

export const buildAppChannelBuildId = (
  ref: AppDeploymentRef,
  commitHash: string
) => `${ref.appId}|${ref.channelId}|${commitHash}`
